// Provider/configuration states are independent of saved service-area geometry.
export const serviceAreaMapTranslations = {
  en: {
    loading: "Loading map…", missing_key: "Basemap unavailable: map authorization is not configured. Your service area is unchanged.",
    native_authorization: "Basemap authorization is not yet available on this device. Your service area is unchanged.",
    authorization: "CARTO refused map access. Check the map key and permitted website.",
    quota: "The map provider's usage limit has been reached. Your service area is unchanged.",
    unavailable: "The basemap could not be loaded. Check your connection and retry.",
    invalid_tile: "The map provider returned an unreadable tile. Please retry.",
    load_error: "Your saved service area could not be loaded. Retry before editing to avoid replacing it.",
  },
  es: {
    loading: "Cargando mapa…", missing_key: "Mapa base no disponible: la autorización no está configurada. Tu área de servicio no ha cambiado.",
    native_authorization: "La autorización del mapa aún no está disponible en este dispositivo. Tu área de servicio no ha cambiado.",
    authorization: "CARTO rechazó el acceso al mapa. Revisa la clave y el sitio web permitido.",
    quota: "Se alcanzó el límite de uso del proveedor del mapa. Tu área de servicio no ha cambiado.",
    unavailable: "No se pudo cargar el mapa base. Comprueba tu conexión e inténtalo de nuevo.",
    invalid_tile: "El proveedor devolvió una imagen del mapa ilegible. Inténtalo de nuevo.",
    load_error: "No se pudo cargar tu área guardada. Vuelve a intentarlo antes de editar para evitar reemplazarla.",
  },
  fr: {
    loading: "Chargement de la carte…", missing_key: "Fond de carte indisponible : autorisation non configurée. Votre zone de service est inchangée.",
    native_authorization: "L’autorisation de la carte n’est pas encore disponible sur cet appareil. Votre zone est inchangée.",
    authorization: "CARTO a refusé l’accès. Vérifiez la clé et le site web autorisé.",
    quota: "La limite d’utilisation du fournisseur est atteinte. Votre zone est inchangée.",
    unavailable: "Impossible de charger le fond de carte. Vérifiez votre connexion et réessayez.",
    invalid_tile: "Le fournisseur a renvoyé une tuile illisible. Réessayez.",
    load_error: "Impossible de charger votre zone enregistrée. Réessayez avant de la modifier pour éviter de la remplacer.",
  },
  de: {
    loading: "Karte wird geladen…", missing_key: "Basiskarte nicht verfügbar: Kartenberechtigung nicht eingerichtet. Ihr Servicegebiet bleibt unverändert.",
    native_authorization: "Die Kartenberechtigung ist auf diesem Gerät noch nicht verfügbar. Ihr Servicegebiet bleibt unverändert.",
    authorization: "CARTO hat den Zugriff verweigert. Prüfen Sie den Schlüssel und die zugelassene Website.",
    quota: "Das Nutzungslimit des Kartenanbieters wurde erreicht. Ihr Servicegebiet bleibt unverändert.",
    unavailable: "Basiskarte konnte nicht geladen werden. Prüfen Sie die Verbindung und versuchen Sie es erneut.",
    invalid_tile: "Der Kartenanbieter hat eine unlesbare Kachel geliefert. Bitte erneut versuchen.",
    load_error: "Ihr gespeichertes Servicegebiet konnte nicht geladen werden. Versuchen Sie es vor dem Bearbeiten erneut, um es nicht zu überschreiben.",
  },
  pt: {
    loading: "Carregando mapa…", missing_key: "Mapa base indisponível: autorização não configurada. Sua área de serviço não foi alterada.",
    native_authorization: "A autorização do mapa ainda não está disponível neste dispositivo. Sua área de serviço não foi alterada.",
    authorization: "O CARTO recusou o acesso ao mapa. Verifique a chave e o site permitido.",
    quota: "O limite de uso do provedor foi atingido. Sua área de serviço não foi alterada.",
    unavailable: "Não foi possível carregar o mapa base. Verifique a conexão e tente novamente.",
    invalid_tile: "O provedor retornou uma imagem de mapa ilegível. Tente novamente.",
    load_error: "Não foi possível carregar sua área salva. Tente novamente antes de editar para não substituí-la.",
  },
  zh: {
    loading: "正在加载地图…", missing_key: "底图不可用：尚未配置地图授权。您的服务区域未更改。",
    native_authorization: "此设备尚不支持地图授权。您的服务区域未更改。",
    authorization: "CARTO 拒绝了地图访问。请检查地图密钥和允许的网站。",
    quota: "已达到地图提供商的使用限额。您的服务区域未更改。",
    unavailable: "无法加载底图。请检查网络连接并重试。", invalid_tile: "地图提供商返回了无法读取的图块。请重试。",
    load_error: "无法加载已保存的服务区域。请先重试，再进行编辑，以免覆盖原有区域。",
  },
  ja: {
    loading: "地図を読み込み中…", missing_key: "地図の認証が未設定のため、背景地図を表示できません。サービスエリアは変更されていません。",
    native_authorization: "この端末では地図の認証がまだ利用できません。サービスエリアは変更されていません。",
    authorization: "CARTO が地図へのアクセスを拒否しました。キーと許可されたサイトを確認してください。",
    quota: "地図プロバイダーの利用上限に達しました。サービスエリアは変更されていません。",
    unavailable: "背景地図を読み込めませんでした。接続を確認して再試行してください。", invalid_tile: "地図プロバイダーから読み取れないタイルが返されました。再試行してください。",
    load_error: "保存済みのサービスエリアを読み込めませんでした。上書きを防ぐため、編集前に再試行してください。",
  },
  ko: {
    loading: "지도 로딩 중…", missing_key: "지도 인증이 설정되지 않아 기본 지도를 사용할 수 없습니다. 서비스 지역은 변경되지 않았습니다.",
    native_authorization: "이 기기에서는 지도 인증을 아직 사용할 수 없습니다. 서비스 지역은 변경되지 않았습니다.",
    authorization: "CARTO가 지도 접근을 거부했습니다. 지도 키와 허용된 웹사이트를 확인하세요.",
    quota: "지도 제공업체의 사용 한도에 도달했습니다. 서비스 지역은 변경되지 않았습니다.",
    unavailable: "기본 지도를 불러오지 못했습니다. 연결을 확인하고 다시 시도하세요.", invalid_tile: "지도 제공업체가 읽을 수 없는 타일을 반환했습니다. 다시 시도하세요.",
    load_error: "저장된 서비스 지역을 불러오지 못했습니다. 덮어쓰지 않도록 편집 전에 다시 시도하세요.",
  },
  it: {
    loading: "Caricamento mappa…", missing_key: "Mappa di base non disponibile: autorizzazione non configurata. La tua area di servizio è invariata.",
    native_authorization: "L’autorizzazione della mappa non è ancora disponibile su questo dispositivo. La tua area è invariata.",
    authorization: "CARTO ha rifiutato l’accesso. Controlla la chiave e il sito web consentito.",
    quota: "È stato raggiunto il limite di utilizzo del fornitore. La tua area è invariata.",
    unavailable: "Impossibile caricare la mappa di base. Controlla la connessione e riprova.", invalid_tile: "Il fornitore ha restituito un riquadro illeggibile. Riprova.",
    load_error: "Impossibile caricare la tua area salvata. Riprova prima di modificarla per evitare di sostituirla.",
  },
  ru: {
    loading: "Загрузка карты…", missing_key: "Базовая карта недоступна: авторизация не настроена. Ваша зона обслуживания не изменена.",
    native_authorization: "Авторизация карты пока недоступна на этом устройстве. Ваша зона обслуживания не изменена.",
    authorization: "CARTO отказал в доступе к карте. Проверьте ключ и разрешённый сайт.",
    quota: "Достигнут лимит использования карт. Ваша зона обслуживания не изменена.",
    unavailable: "Не удалось загрузить базовую карту. Проверьте соединение и повторите попытку.", invalid_tile: "Поставщик карты вернул нечитаемую плитку. Повторите попытку.",
    load_error: "Не удалось загрузить сохранённую зону. Повторите попытку перед редактированием, чтобы не перезаписать её.",
  },
  ht: {
    loading: "Kat la ap chaje…", missing_key: "Kat debaz la pa disponib: otorizasyon an poko konfigire. Zòn sèvis ou pa chanje.",
    native_authorization: "Otorizasyon kat la poko disponib sou aparèy sa a. Zòn sèvis ou pa chanje.",
    authorization: "CARTO refize aksè a kat la. Verifye kle a ak sit entènèt ki otorize a.",
    quota: "Limit itilizasyon founisè kat la rive. Zòn sèvis ou pa chanje.",
    unavailable: "Kat debaz la pa ka chaje. Verifye koneksyon ou epi eseye ankò.", invalid_tile: "Founisè a voye yon imaj kat ki pa lizib. Eseye ankò.",
    load_error: "Zòn sèvis ou te sove a pa ka chaje. Eseye ankò anvan ou modifye l pou evite ranplase l.",
  },
};